import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
export default {
  getAll() {
    return raw.getAll(routes.myEntitlements.all());
  },
  get(entitlementType) {
    return raw.get(routes.myEntitlements.one(entitlementType));
  },
};
